export default __webpack_public_path__ + "static/media/santa-on-phone.d5171628.jpg";